// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IClaimFileModel {
    'fileContents'?: string;
    'fileName'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IClaimFileModel>> = [
        {
            "name":     "fileContents",
            "baseName": "fileContents",
            "type":     "string"
        },
        {
            "name":     "fileName",
            "baseName": "fileName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IClaimFileModel.attributeTypeMap;
    }
}
